import { render, staticRenderFns } from "./ApprovalNode.vue?vue&type=template&id=33bf4384&scoped=true"
import script from "./ApprovalNode.vue?vue&type=script&lang=js"
export * from "./ApprovalNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf4384",
  null
  
)

export default component.exports